import { Integer, CurrencyFloat, PercentageFloat, Double, Untyped } from '../../common';

export interface AccountLabel {
    id: string; // Long
    name: string;
}

export interface ManagedCustomer {
    name: string;
    // CompanyName : string;
    customerId: string;
    canManageClients: boolean;
    currencyCode: string;
    // DescriptiveName : string;
    dateTimeZone: string;
    testAccount: boolean;
    accountLabels: AccountLabel[];
    excludeHiddenAccounts: boolean;
}

export interface AccessibleCustomer {
    name?: string;
    customerId: string;
}

export interface AdWordsCommonStats {
    currency: string;
    impressions: Integer;
    clicks: Integer;
    cost: CurrencyFloat;
    CPC: CurrencyFloat;
    CTR: PercentageFloat;
    conversions: Double;
}

export interface AdWordsLocationStats extends AdWordsCommonStats {
    keywords: AdWordsKeywordStats[];
    areSearchImpressionsLimitedByBudget: boolean;
    areSearchImpressionsLimitedByRank: boolean;
}

export interface AdWordsKeywordStats extends AdWordsCommonStats {
    adGroupName: string;
    keywordText: string;
}

export type AdWordStats = AdWordsKeywordStats | AdWordsLocationStats;

export function isAdWordsLocationStats(stats: AdWordStats): stats is AdWordsLocationStats {
    const keywordsFieldName: keyof AdWordsLocationStats = 'keywords';
    return !!(stats as Untyped)[keywordsFieldName];
}

export function isAdWordsKeywordStats(stats: AdWordStats): stats is AdWordsKeywordStats {
    const keywordsFieldName: keyof AdWordsKeywordStats = 'keywordText';
    return !!(stats as Untyped)[keywordsFieldName];
}

export interface CampaignIdentity {
    id: string;
    name: string;
}

export interface LostImpressionPercentage {
    type: 'exactly' | 'greaterThan';
    value: PercentageFloat;
}
